import { useTranslation } from 'react-i18next';

import CommonButton from '~atoms/CommonButton';
import * as WarningModalSt from '~molecules/WarningModal/WarningModal.styles';

type ZipNotServicedModalProps = {
  isOnlineRetailer: boolean;
  isVisible: boolean;
  onOk: () => void;
};

const ZipNotServicedModal = ({
  isOnlineRetailer,
  isVisible,
  onOk,
}: ZipNotServicedModalProps) => {
  const { t } = useTranslation();
  const contentKey = isOnlineRetailer
    ? 'STORE_PAGE.NO_STORE_ONLINE'
    : 'STORE_PAGE.NO_STORE';

  if (!isVisible) {
    return null;
  }

  return (
    <WarningModalSt.Container
      type="warning"
      title={t('EQUIVALENT_PRODUCT_MATCHING.ZIP_CODE.ALERT_TITLE')}
      content={t(contentKey)}
      isVisible={isVisible}
      closable={false}
      keyboard={false}
      maskClosable={false}
      onClose={onOk}
      footer={[
        <CommonButton key="ok" onClick={onOk} data-style="warning-primary">
          OK
        </CommonButton>,
      ]}
    />
  );
};

export default ZipNotServicedModal;
